import { Col, Container, Row } from "react-bootstrap"
import Title from "./Title"
import '../style/scss/ourTeam.scss';

const OurTeam = () => {
    const TeamMembers = [
        {avartar: require('../style/images/team/team-img-1.png'), name: 'Aladdin', job: 'CEO & Founder', desc: 'Head of Development'},
        {avartar: require('../style/images/team/team-img-2.png'), name: 'Adam', job: 'COO & Co Founder', desc: 'Head of Operations'},
        {avartar: require('../style/images/team/team-img-3.png'), name: 'Nicolas', job: 'CFO', desc: 'Accountant'},
        {avartar: require('../style/images/team/team-img-4.png'), name: 'Naim', job: 'CTO', desc: 'Technical Manager'},
    ]
    return (
        <Container id="TeamSection">
            <Title title={"Our Team"} />
            <Row className="our-team">
                {
                    TeamMembers.map((member, index) => {
                        return (
                            <Col lg={3} md={4} sm={3} xs={12} key={index} className="content">
                                <div className="profile">
                                    <img src={member.avartar} alt="" width="265" height="265" />
                                    <p className="name text-center">{member.name}</p>
                                    <p className="job text-center">{member.job}</p>
                                    <p className="desc text-center">{member.desc}</p>
                                </div>
                            </Col>
                        )
                    })
                }
            </Row>
        </Container>
    )
}

export default OurTeam;